module.exports = __webpack_public_path__ + "img/ryzs2.7c7b6373.png";